<div class="dropdown">
  <button
    part="button"
    type="button"
    class="btn btn-primary dropdown-toggle"
    (click)="onButtonClick()"
    (blur)="onButtonBlur($event)"
    #button>
    {{ text }}
  </button>
  <div
    tabindex="-1"
    part="menu"
    [ngClass]="{
      'dropdown-menu p-2 shadow show': true,
      'visible': open,
      'invisible': !open
    }"
    [style.--menu-y]="menuY"
    [style.--menu-x]="menuX"
    (blur)="onMenuBlur($event)"
    #menu>
    <slot
      (slotchange)="onSlottedContentChanged()"
      #slot>
    </slot>
  </div>
</div>
